import { render } from "./pddprint.vue?vue&type=template&id=68d629c4"
import script from "./pddprint.vue?vue&type=script&lang=js"
export * from "./pddprint.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__